import { Colors } from '@honeyscience/honey-ui-toolkit';
import React, { ReactElement } from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  container: {
    borderBottom: `1px solid ${Colors.grey200}`,
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '32px',
    paddingBottom: '24px',
    textAlign: 'left',
  },
  description: {
    color: `1px solid ${Colors.grey200}`,
    composes: 'body5',
  },
  title: {
    composes: 'h2',
  },
});

type HeaderProps = {
  title?: string;
  description?: string;
};

function Header({ title, description }: HeaderProps): ReactElement {
  const classes = useStyles();

  return (
    <div className={ classes.container }>
      <div className={ classes.title }>{ title }</div>
      <div className={ classes.description }>{ description }</div>
    </div>
  );
}

Header.defaultProps = {
  description: '',
  title: '',
};

export default Header;
